var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "confirm_area", attrs: { id: "corp_confirm" } },
    [
      _c("div", { staticClass: "input_confirm" }, [
        _c("ul", [
          !_vm.isPrivateUser
            ? _c("li", [
                _c("span", [_vm._v("会社名：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.corpForm.corpName))])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isPrivateUser
            ? _c("li", [
                _c("span", [_vm._v("支店名・営業所名：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.corpForm.corpBranchName))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("メールアドレス：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.corpForm.email))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("電話番号：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.corpForm.tel))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("FAX番号：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.corpForm.fax))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("郵便番号：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.corpForm.postcd))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("住所：")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.corpForm.state) + " " + _vm._s(_vm.corpForm.city)
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("以下住所：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.corpForm.street))])
          ]),
          _vm._v(" "),
          !_vm.isEdit
            ? _c("li", [
                _c("span", [_vm._v("招待コード：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.corpForm.inviteCode))])
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22b2532c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22b2532c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/user/DcCorpConfirm.vue
// module id = null
// module chunks = 